import { MapperBase } from '../../../utilities/mapper-base';
import { ArchiveJob } from '../../archive-job.model';
import { ArchiveJobResource } from '../../resource/archive-job.resource';

export class ArchiveJobToArchiveJobResourceMapper extends MapperBase<ArchiveJob, ArchiveJobResource> {
	map(source: ArchiveJob): ArchiveJobResource {
		return {
			archiveJobId: source.archiveJobId,
			caseId: source.caseId,
			title: source.title,
			comments: source.comments,
			createdById: source.createdById,
			dateTimeCreated: source.dateTimeCreated,
			runById: source.runById,
			dateTimeRun: source.dateTimeRun,
			archiveBaseNumberStart: source.archiveBaseNumberStart,
			archiveBaseNumberDigits: source.archiveBaseNumberDigits,
			isCreateTiff: source.isCreateTiff,
			docSizeArchived: 0,//not saved or used
			//docSizeArchived: source.docSizeArchived,
			lifeCycle: source.lifeCycle,
			status: source.status
		} as ArchiveJobResource;
	}
}